import { Stack } from '@mui/material';

import { useSwimlaneEventPublisher } from '../../api/useSwimlaneEventPublisher';

import { NoSubItemsIcon } from './icons/NoSubItemsIcon';
import {
  FooterTypography,
  StyledBox,
  StyledButtonFilled,
  StyledDiv,
  StyledDivider,
  SubtitleTypography,
  TitleTypography,
} from './StyledComponents';

export function NoSubItems({ isMaster = false }: { isMaster?: boolean }) {
  const publishEvent = useSwimlaneEventPublisher();
  const subTitleText = isMaster
    ? 'Parent fields can only be displayed on roadmaps with Sub-Items.'
    : 'Please confirm that Sub-Items are visible in your Table View.';
  const action = isMaster ? 'edit-headers' : 'view-table';
  const actionCTA = isMaster ? 'Edit headers' : 'Go to table view';
  return (
    <StyledDiv>
      <StyledBox>
        <NoSubItemsIcon />
        <TitleTypography>No Sub-Items Found</TitleTypography>
        <SubtitleTypography>{subTitleText}</SubtitleTypography>
        <Stack direction="row" gap={3}>
          <StyledButtonFilled
            variant="contained"
            onClick={() => publishEvent('emptyStateButtonClicked', { action })}
          >
            {actionCTA}
          </StyledButtonFilled>
        </Stack>
        <StyledDivider variant="middle" />
        <FooterTypography>
          Need more guidance?
          <br />
          <a
            href="https://help.tempo.io/roadmaps/latest/visualizing-sub-items-on-roadmaps"
            target="_blank"
            rel="noreferrer"
          >
            Visit the Tempo Help Center
          </a>
        </FooterTypography>
      </StyledBox>
    </StyledDiv>
  );
}
